export default "__VITE_ASSET__BgN5ajHQ__"